// ============================================================
// DATASET INTELLIGENCE (Overview + Data Quality)
// ============================================================
// Replaces the old "generic chart" section of the dashboard. The dashboard
// answers "what should I know about this dataset?" — structural profile
// and health, not a specific analytical chart (that belongs to chat).

export function buildOverview(schema, dataset) {

  const timeCols = schema?.time || [];
  const categoricalCols = (schema?.dimensions || []).filter(d => !timeCols.includes(d));

  return {
    records: dataset.length,
    columns: schema?.columns?.length || 0,
    numericColumns: schema?.measures?.length || 0,
    categoricalColumns: categoricalCols.length,
    dateColumns: timeCols.length,
  };
}

export function buildDataQuality(dataset, schema) {

  const columns = schema?.columns || Object.keys(dataset[0] || {});

  const missingValueColumns = columns
    .map(col => {
      const missing = dataset.filter(r => r[col] === "" || r[col] === null || r[col] === undefined).length;
      return { column: col, missingCount: missing, missingPercent: (missing / dataset.length) * 100 };
    })
    .filter(c => c.missingCount > 0)
    .sort((a, b) => b.missingPercent - a.missingPercent);

  // Duplicate row detection — exact duplicates only, cheap and unambiguous.
  const seen = new Set();
  let duplicateCount = 0;

  for (const row of dataset) {
    const key = JSON.stringify(row);
    if (seen.has(key)) duplicateCount++;
    else seen.add(key);
  }

  // Type warnings: a column classified as a measure where a meaningful
  // share of values don't actually parse as numbers suggests
  // misclassification or dirty data worth flagging.
  const typeWarnings = (schema?.measures || [])
    .map(col => {
      const values = dataset.map(r => r[col]).filter(v => v !== "" && v !== null && v !== undefined);
      if (!values.length) return null;
      const nonNumeric = values.filter(v => isNaN(parseFloat(v))).length;
      const pct = (nonNumeric / values.length) * 100;
      return pct >= 5 ? { column: col, issue: `${pct.toFixed(1)}% of values are not numeric` } : null;
    })
    .filter(Boolean);

  return {
    missingValueColumns,
    duplicateCount,
    typeWarnings,
    isClean: missingValueColumns.length === 0 && duplicateCount === 0 && typeWarnings.length === 0,
  };
}
